<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ProjectWorkspaceSwitcherViewModel } from '@Projects/Components/ProjectWorkspaceSwitcher';

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ProjectWorkspaceSwitcher extends Vue
    {
        get vm(): ProjectWorkspaceSwitcherViewModel { return this.$props.viewModel as ProjectWorkspaceSwitcherViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
        get initialized(): boolean { return this.vm.initialized; }
        get workspaces() { return this.vm.workspaces; }

        get workspaceId(): number { return this.vm.workspaceId; }
        get projectName(): string { return this.vm.projectName; }

        get newWorkspaceId(): number { return this.vm.newWorkspaceId; }
        set newWorkspaceId(val: number) { this.vm.newWorkspaceId = val; }

        handleMoveProject()
        {
            if (this.newWorkspaceId !== this.workspaceId)
            {
                this.$emit('move-project', this.vm.projectId, this.newWorkspaceId);
            }
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Switch Workspace for Your Project</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h4 v-if="!initialized"><i class="fa fa-spinner fa-spin"></i> Loading...</h4>
                        <div v-if="initialized">
                            <p>Move your project <strong>'{{projectName}}'</strong> to a different workspace. Select the destination workspace from the list below.</p>
                            <p>
                                <select v-model="newWorkspaceId" class="form-control">
                                    <option v-for="w in workspaces" :value="w.WorkspaceId">{{w.Name}}</option>
                                </select>
                            </p>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="handleMoveProject" :disabled="newWorkspaceId === workspaceId" class="btn btn-primary">Save</button>
                        <button type="button" @click="close" class="btn btn-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

